// @core/api/endpoints/workflow/execute_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExecutePipelineRequest,
  PipelineExecutionResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Execute pipeline
 * Triggers a pipeline execution using the currently published version. Optionally provide trigger data as input.
 */
export async function ExecutePipeline(
  pipeline_id: string,
  data: ExecutePipelineRequest,
  options?: RequestOptions
): Promise<PipelineExecutionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/execute`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<PipelineExecutionResponse>(requestPath, data, requestOptions);
}
